import { getLocale } from "../runtime";

const sv_percentoff = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `rabatt`
};

const percentoff = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_percentoff(inputs)
	return "percentOff";
};

export { percentoff as "percentOff" };